// /src/services/settlementsService.js
import { db } from "./firebase";
import {
    collection,
    getDocs,
    query,
    where,
    orderBy,
    limit as fsLimit,
} from "firebase/firestore";
import { normalizeFranchiseName } from "./normalize";

const COL = collection(db, "settlements_raw");

const settlementsRawCol = collection(db, "settlements_raw");

// 🔹 시스템 전체 기준 "가장 최신 정산달" 한 번만 찾기
async function getSystemLatestSettlementMonthKey() {
    console.log("[settlements] getSystemLatestSettlementMonthKey START");
    try {
        const qLatest = query(
            settlementsRawCol,
            orderBy("settlementMonthKey", "desc"),
            fsLimit(1)
        );
        const snap = await getDocs(qLatest);
        if (snap.empty) {
            console.log("[settlements] no settlements_raw docs at all");
            return null;
        }

        const d = snap.docs[0].data() || {};
        const key =
            d.settlementMonthKey ||
            (d.payload && d.payload.settlementMonthKey) ||
            null;

        console.log(
            "[settlements] system latest settlementMonthKey =",
            key
        );
        return key;
    } catch (e) {
        console.error(
            "[settlements] getSystemLatestSettlementMonthKey ERROR:",
            e?.message || e
        );
        return null;
    }
}


/* ──────────────────────────────────────────────
   월별 매출 합산 — 특정 연도 / 가맹점 기준
   - franchiseName: approvals에서 쓰는 조인키(운수사명)
   - year: 2025 이런 숫자
   - 1~12월 각각 settlements_raw 에서 totalFare 합산
   - 결과: [{ month, label, sales }, ...] (1~12월 고정)
───────────────────────────────────────────────*/
export async function fetchMonthlyFaresByFranchise(franchiseName, year) {
    if (!franchiseName || !year) return [];

    const col = collection(db, "settlements_raw");

    console.log("[monthly] year =", year, "franchisename =", franchiseName);
    
    const results = [];

    for (let m = 1; m <= 12; m += 1) {
        const monthKey = `${year}-${String(m).padStart(2, "0")}`;
        let sum = 0;
        let call = 0;

        try {
            const qy = query(
                col,
                where("settlementMonthKey", "==", monthKey),
                where("payload.franchiseName", "==", franchiseName)
            );
            const snap = await getDocs(qy);
            snap.forEach((docSnap) => {
                const d = docSnap.data() || {};

                const full = d?.payload?.fullRow || {};

                console.log("fulldata", full);

                const v =
                    full["총운임(vat포함)"] ??
                    0;
                const n = Number(v) || 0;
                if (Number.isFinite(n)) sum += n;

                const c =
                    full["분배액"] ??
                    0;
                const e = Number(c) || 0;
                if (Number.isFinite(e)) call += e;

            });
        } catch (e) {
            console.warn("[fetchMonthlyFaresByFranchise] error", monthKey, e?.message || e);
        }

        results.push({
            month: m,
            label: `${m}월`,
            sales: sum,
            call: call,
        });
    }

    return results;
}

// 🔹 1) 특정 가맹점의 "가장 최신 settlementMonthKey" 찾기 + 로그
async function getLatestMonthKeyForFranchise(franchiseName) {
    if (!franchiseName) return null;

    console.log(
        "[sumTotalFareByFranchise] step1: find latest monthKey for",
        franchiseName
    );

    try {
        
        const qLatest = query(
            settlementsRawCol,
            where("payload.franchiseName", "==", franchiseName),
            orderBy("settlementMonthKey", "desc"),
            fsLimit(20) // 최신 20개만 보면 충분
        );

        const snap = await getDocs(qLatest);

        if (snap.empty) {
            console.log(
                "[sumTotalFareByFranchise] step1: no settlements for",
                franchiseName
            );
            return null;
        }

        // 샘플 몇 개 로그
        const sample = snap.docs.slice(0, 5).map((docSnap) => {
            const d = docSnap.data() || {};
            const p = d.payload || {};
            return {
                id: docSnap.id,
                settlementMonthKey: d.settlementMonthKey,
                payloadMonthKey: p.settlementMonthKey,
                franchiseNamePayload: p.franchiseName,
                totalFare: p.totalFare,
            };
        });

        console.log(
            "[sumTotalFareByFranchise] step1: sample docs for",
            franchiseName,
            sample
        );

        const first = snap.docs[0].data() || {};
        const key =
            first.settlementMonthKey ||
            (first.payload && first.payload.settlementMonthKey) ||
            null;

        console.log(
            "[sumTotalFareByFranchise] step1: picked latest monthKey =",
            key
        );

        return key;
    } catch (e) {
        console.error(
            "[sumTotalFareByFranchise] step1 ERROR (likely index 문제일 수 있음):",
            e?.message || e
        );
        // 여기서 에러 메시지에 "The query requires an index" 나오면
        // 콘솔 링크 눌러서 인덱스 한 번 만들어주면 됨.
        return null;
    }
}

// 🔹 2) "마지막 정산달" 기준 총 운임 합계 + 로그
export async function sumTotalFareByFranchise(franchiseName) {
    if (!franchiseName) return 0;

    console.log(
        "[sumTotalFareByFranchise] ===== START for",
        franchiseName,
        "====="
    );

    const monthKey = await getLatestMonthKeyForFranchise(franchiseName);
    if (!monthKey) {
        console.log(
            "[sumTotalFareByFranchise] abort: no latest monthKey for",
            franchiseName
        );
        return 0;
    }

    try {
        console.log(
            "[sumTotalFareByFranchise] step2: sum fares for",
            franchiseName,
            "in monthKey",
            monthKey
        );

        const qMonth = query(
            settlementsRawCol,
            where("payload.franchiseName", "==", franchiseName),
            where("settlementMonthKey", "==", monthKey)
        );

        const snap = await getDocs(qMonth);
        if (snap.empty) {
            console.log(
                "[sumTotalFareByFranchise] step2: no docs for",
                franchiseName,
                "in monthKey",
                monthKey
            );
            return 0;
        }

        let total = 0;
        const sampleRows = [];

        snap.forEach((docSnap, idx) => {
            const d = docSnap.data() || {};
            const p = d.payload || {};
            const fare =
                (typeof p.totalFare === "number" && p.totalFare) ||
                (typeof p.fare === "number" && p.fare) ||
                (typeof d.totalFare === "number" && d.totalFare) ||
                0;

            total += fare;

            if (idx < 5) {
                sampleRows.push({
                    id: docSnap.id,
                    settlementMonthKey: d.settlementMonthKey,
                    payloadMonthKey: p.settlementMonthKey,
                    totalFare: p.totalFare,
                    fareField: p.fare,
                    usedFare: fare,
                });
            }
        });

        console.log(
            "[sumTotalFareByFranchise] step2: sample rows for",
            franchiseName,
            "in month",
            monthKey,
            sampleRows
        );
        console.log(
            "[sumTotalFareByFranchise] RESULT latest-month totalFare for",
            franchiseName,
            "(",
            monthKey,
            ") =",
            total
        );

        return total;
    } catch (e) {
        console.error(
            "[sumTotalFareByFranchise] step2 ERROR (maybe index 문제):",
            e?.message || e
        );
        return 0;
    }
}

// 🔹 특정 가맹점의 "가장 최신 정산달" 한 건만 가져와서 매출 합계 반환
// export async function fetchLatestMonthlyFareByFranchise(franchiseName) {
//     if (!franchiseName) return 0;

//     console.log(
//         "[fetchLatestMonthlyFareByFranchise] START for",
//         franchiseName
//     );

//     try {
//         // settlementMonthKey 기준으로 최신 1건만 조회
//         const qLatest = query(
//             settlementsRawCol,
//             where("payload.franchiseName", "==", franchiseName),
//             orderBy("settlementMonthKey", "desc"),
//             fsLimit(1)
//         );

//         const snap = await getDocs(qLatest);
//         if (snap.empty) {
//             console.log(
//                 "[fetchLatestMonthlyFareByFranchise] no doc for",
//                 franchiseName
//             );
//             return 0;
//         }

//         const d = snap.docs[0].data() || {};
//         const p = d.payload || {};

//         const fareRaw =
//             (typeof p.totalFare === "number" && p.totalFare) ||
//             (typeof p.fare === "number" && p.fare) ||
//             (typeof d.totalFare === "number" && d.totalFare) ||
//             0;

//         const fare =
//             typeof fareRaw === "number"
//                 ? fareRaw
//                 : Number(String(fareRaw).replace(/[,\s]/g, "")) || 0;

//         console.log(
//             "[fetchLatestMonthlyFareByFranchise] latest monthKey =",
//             d.settlementMonthKey,
//             "fare =",
//             fare
//         );
//         return fare;
//     } catch (e) {
//         console.error(
//             "[fetchLatestMonthlyFareByFranchise] ERROR:",
//             e?.message || e
//         );
//         // 인덱스 없으면 여기에서 "This query requires an index" 로그 뜸
//         return 0;
//     }
// }

// 🔹 특정 가맹점의 "가장 최신 정산달" 한 건만 가져와서 매출 합계 + 정산월 반환
// 🔹 특정 가맹점의 "시스템 최신 정산달" 기준 매출 합계 + 정산월 반환
export async function fetchLatestMonthlyFareByFranchise(franchiseName) {
    if (!franchiseName) {
        return {
            fare: 0,
            settlementMonthKey: null,
            settlementMonth: null,
        };
    }

    console.log(
        "[fetchLatestMonthlyFareByFranchise] START for",
        franchiseName
    );

    try {
        // 1) 시스템 전체 기준 최신 정산달 찾기
        const latestMonthKey = await getSystemLatestSettlementMonthKey();
        if (!latestMonthKey) {
            console.log(
                "[fetchLatestMonthlyFareByFranchise] no system latest monthKey"
            );
            return {
                fare: 0,
                settlementMonthKey: null,
                settlementMonth: null,
            };
        }

        console.log(
            "[fetchLatestMonthlyFareByFranchise] system latest monthKey =",
            latestMonthKey,
            "for franchiseName =",
            franchiseName
        );

        // 2) 그 정산달 + 해당 가맹점에 대해 매출 합계
        const qMonth = query(
            settlementsRawCol,
            where("payload.franchiseName", "==", franchiseName),
            where("settlementMonthKey", "==", latestMonthKey)
        );

        const snap = await getDocs(qMonth);
        if (snap.empty) {
            console.log(
                "[fetchLatestMonthlyFareByFranchise] no docs for",
                franchiseName,
                "in system latest monthKey",
                latestMonthKey
            );
            return {
                fare: 0,
                settlementMonthKey: latestMonthKey,
                settlementMonth: latestMonthKey,
            };
        }

        let total = 0;
        const sampleRows = [];

        snap.forEach((docSnap, idx) => {
            const d = docSnap.data() || {};
            const p = d.payload || {};
            const fareRaw =
                (typeof p.totalFare === "number" && p.totalFare) ||
                (typeof p.fare === "number" && p.fare) ||
                (typeof d.totalFare === "number" && d.totalFare) ||
                0;

            const fare =
                typeof fareRaw === "number"
                    ? fareRaw
                    : Number(String(fareRaw).replace(/[,\s]/g, "")) || 0;

            total += fare;

            if (idx < 5) {
                sampleRows.push({
                    id: docSnap.id,
                    settlementMonthKey: d.settlementMonthKey,
                    payloadMonthKey: p.settlementMonthKey,
                    totalFare: p.totalFare,
                    fareField: p.fare,
                    usedFare: fare,
                });
            }
        });

        console.log(
            "[fetchLatestMonthlyFareByFranchise] sample rows for",
            franchiseName,
            "in system latest month",
            latestMonthKey,
            sampleRows
        );
        console.log(
            "[fetchLatestMonthlyFareByFranchise] RESULT totalFare for",
            franchiseName,
            "(",
            latestMonthKey,
            ") =",
            total
        );

        const settlementMonthKey = latestMonthKey;
        const settlementMonth = latestMonthKey;

        return {
            fare: total,
            settlementMonthKey,
            settlementMonth,
        };
    } catch (e) {
        console.error(
            "[fetchLatestMonthlyFareByFranchise] ERROR:",
            e?.message || e
        );
        return {
            fare: 0,
            settlementMonthKey: null,
            settlementMonth: null,
        };
    }
}
